export default __webpack_public_path__ + "static/media/publish-icon.c98ea30a.svg";